import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import "./dataTable.css";
import { compareString } from "../../util/utility.js";
import { userConstants } from "../../constants";
import Button from "react-bootstrap/Button";

class DataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 10,
      records: 0,
      sortColumnName: "",
      sortOrder: "",
      blocking: true,
      role: [],
      multipleDelete: [],
      isDisable: true,
      count: 0,
      totalDownloadSize: 0,
      isBulkDisable: true,
    };
    this.addLink = this.addLink.bind(this);
    this.handleBulkDownload = this.handleBulkDownload.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  addLink(cell, row) {
    return (
      <a
        href="#"
        onClick={this.props.onDownloadHandler}
        invnumber={row.invoiceNumber}
        invdate={row.invoiceDate}
        nmsccode={row.nmscCode}
        filename={cell}
      >
        {cell}
      </a>
    );
  }
  handleBulkDownload = () => {
    console.log("Handle Bulk Download this. is", this);
    console.log("MultipleDownload:", this.state.multipleDownload);
    this.props.onBulkDowloadHandler();
  };
  handleDelete = () => {
    console.log("this. is", this);
    console.log("MultipleDelete:", this.state.multipleDelete);
    this.props.onMultipleDeleteHandler(this.state.multipleDelete);
  };
  handleOnSelect = (row, isSelect) => {
    console.log("rowSelect:", row, "isSelect:", isSelect);
    if (isSelect) {
      this.state.count++;
      this.setState({ isDisable: false });
      this.setState(() => ({
        multipleDelete: [...this.state.multipleDelete, row.invoiceId],
      }));
    } else {
      this.state.count--;
      this.setState(() => ({
        multipleDelete: this.state.multipleDelete.filter(
          (x) => x !== row.invoiceId
        ),
      }));
    }
    // if(this.state.multipleDelete.length===0){
    //     this.setState({isDisable:true})
    // }else{
    //     this.setState({isDisable:false})
    // }
    //     console.log('Multi',this.state.multipleDelete);
    if (this.state.count === 0) {
      this.setState({ isDisable: true });
    }
  };
  pageChanged(pageNumber) {
    this.setState({ pageNumber: pageNumber });
    this.props.paginationHandler(
      pageNumber,
      this.state.pageSize,
      this.state.sortColumnName,
      this.state.sortOrder
    );
  }

  sortChanged(sortColumn, order) {
    this.setState({ sortColumnName: sortColumn });
    this.setState({ currentPage: 1 });
    let sortOrder = order.toString().toLowerCase() === "asc" ? "desc" : "asc";
    this.setState({ sortOrder: sortOrder });
    if (sortColumn === "invoiceNumber") {
      sortColumn = "number";
    }
    this.props.paginationHandler(
      this.state.pageNumber,
      this.state.pageSize,
      sortColumn,
      sortOrder
    );
  }
  sizePerPageListChange(sizePerPage) {
    this.setState({ pageSize: sizePerPage });
    this.props.paginationHandler(
      this.state.pageNumber,
      sizePerPage,
      this.state.sortColumnName,
      this.state.sortOrder
    );
  }

  renderShowsTotal(start, to, total) {
    console.log(
      "start:",
      start,
      "to:",
      to,
      "total:",
      total,
      "--",
      this.state.records
    );
    var text =
      "Showing " +
      start +
      " to " +
      to +
      " of " +
      this.state.records +
      " records.";
    return <p style={{ color: "blue" }}>{text}</p>;
  }
  handleOnSelectAll = (isSelect, rows) => {
    console.log("Rows:", rows);
    const multipleInvoiceDelete = rows.map((r) => r.invoiceId);
    if (isSelect) {
      this.setState({ isDisable: false });
      this.setState(() => ({
        multipleDelete: multipleInvoiceDelete,
      }));
    } else {
      this.setState({ isDisable: true });
      this.setState(() => ({
        multipleDelete: [],
      }));
    }
  };
  selectRowProp = {
    mode: "checkbox",
    //clickToSelect: true,
    checkbox: true,
    bgColor: "rgb(238, 193, 213)",
    onSelect: this.handleOnSelect,
    onSelectAll: this.handleOnSelectAll,
  };
  /* componentWillMount() {
        console.log("Props will mount" + this.props);
        if(this.props.downloadSize>0){
            this.setState({isBulkDisable:false});
         }

    } */
  componentWillReceiveProps(nextProps) {
    console.log("This.props.Invoice:", this.props);
    console.log("InvoiceNextProps:", nextProps);
    if (nextProps.data) {
      this.setState({ records: nextProps.data.records });
      this.setState({ role: nextProps.role });
      this.setState({ totalDownloadSize: nextProps.downloadSize });
      //  if(this.state.totalDownloadSize>0){
      //     this.setState({isBulkDisable:true});
      //  }
    }
    if (nextProps.deleteStatus) {
      this.setState(() => ({
        multipleDelete: [],
      }));
      this.state.count = 0;
      this.state.isDisable = true;
      this.props.onCancel();
    }
  }
  /* setDisableBulk= ()=>{
        console.log()
        if(this.state.totalDownloadSize>0){
            this.setState({isBulkDisable:false});
         }
    } */
  render() {
    var textSize = "Size(IN MB):" + this.state.totalDownloadSize;
    const options = {
      page: this.state.currentPage,
      sizePerPage: 10,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      paginationShowsTotal: this.renderShowsTotal.bind(this),
      onPageChange: this.pageChanged.bind(this),
      onSizePerPageList: this.sizePerPageListChange.bind(this),
      onSortChange: this.sortChanged.bind(this),
    };
    console.log("Render Count:", this.state.count);
    console.log("Render Disable:", this.state.isDisable);
    return (
      <div className="table">
        {this.state.role.includes("EDOC INVOICE ADMIN") ? (
          <div>
            {this.props.showResults && this.props.data ? (
              <div>
                <BootstrapTable
                  data={this.props.data.invoices}
                  options={options}
                  pagination={true}
                  keyField={"invoiceId"}
                  selectRow={this.selectRowProp}
                  fetchInfo={{ dataTotalSize: this.state.records }}
                  remote={true}
                >
                  <TableHeaderColumn
                    dataField="invoiceNumber"
                    dataAlign="center"
                    dataSort={true}
                  >
                    Invoice No
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="invoiceDate"
                    dataAlign="center"
                    dataSort={true}
                  >
                    Invoice Date
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="amount"
                    dataAlign="center"
                    dataSort={true}
                  >
                    Amount
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="currency"
                    dataAlign="center"
                    dataSort={true}
                  >
                    Currency
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="pdf"
                    dataFormat={this.addLink}
                    dataAlign="center"
                  >
                    Invoice{" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="validationHtml"
                    dataFormat={this.addLink}
                    dataAlign="center"
                  >
                    Validation Report{" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="validationXml"
                    dataFormat={this.addLink}
                    dataAlign="center"
                  >
                    Validation XML{" "}
                  </TableHeaderColumn>
                </BootstrapTable>
                <Button
                  className="primary"
                  disabled={this.state.isDisable}
                  onClick={this.handleDelete}
                >
                  Delete
                </Button>
                <Button
                  className="primary"
                  style={{ marginLeft: "1%" }}
                  onClick={this.handleBulkDownload}
                >
                  Bulk Download
                </Button>
                {
                  <p style={{ color: "black", marginLeft: "90px" }}>
                    {textSize}
                  </p>
                }
              </div>
            ) : null}
          </div>
        ) : null}
        {this.state.role.includes("EDOC TME USER") ||
        this.state.role.includes("EDOC NMSC USER") ||
        this.state.role.includes("EDOC TME AF USER") ? (
          <div>
            <div className="table">
              {this.props.showResults && this.props.data ? (
                <div>
                  <BootstrapTable
                    data={this.props.data.invoices}
                    options={options}
                    pagination={true}
                    keyField={"invoiceId"}
                    fetchInfo={{ dataTotalSize: this.state.records }}
                    remote={true}
                  >
                    <TableHeaderColumn
                      dataField="invoiceNumber"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Invoice No
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="invoiceDate"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Invoice Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="amount"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Amount
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="currency"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Currency
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="pdf"
                      dataFormat={this.addLink}
                      dataAlign="center"
                    >
                      Invoice{" "}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="validationHtml"
                      dataFormat={this.addLink}
                      dataAlign="center"
                    >
                      Validation Report{" "}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="validationXml"
                      dataFormat={this.addLink}
                      dataAlign="center"
                    >
                      Validation XML{" "}
                    </TableHeaderColumn>
                  </BootstrapTable>
                  <Button className="primary" onClick={this.handleBulkDownload}>
                    Bulk Download
                  </Button>
                  {<p style={{ color: "black" }}>{textSize}</p>}
                </div>
              ) : null}
            </div>{" "}
          </div>
        ) : null}
        {this.state.role.includes("EDOC SUPPLIER USER") ||
        this.state.role.includes("EDOC INVOICE AUDITOR") ? (
          <div>
            <div className="table">
              {this.props.showResults && this.props.data ? (
                <div>
                  <BootstrapTable
                    data={this.props.data.invoices}
                    options={options}
                    pagination={true}
                    keyField={"invoiceId"}
                    fetchInfo={{ dataTotalSize: this.state.records }}
                    remote={true}
                  >
                    <TableHeaderColumn
                      dataField="invoiceNumber"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Invoice No
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="invoiceDate"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Invoice Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="amount"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Amount
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="currency"
                      dataAlign="center"
                      dataSort={true}
                    >
                      Currency
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="pdf"
                      dataFormat={this.addLink}
                      dataAlign="center"
                    >
                      Invoice{" "}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="validationHtml"
                      dataFormat={this.addLink}
                      dataAlign="center"
                    >
                      Validation Report{" "}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="validationXml"
                      dataFormat={this.addLink}
                      dataAlign="center"
                    >
                      Validation XML{" "}
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              ) : null}
            </div>{" "}
          </div>
        ) : null}
      </div>
    );
  }
}

export default DataTable;
